export default "__VITE_ASSET__$Vsgsj5U__"